export enum EDocumentUploaderMode {
  CLICK = 'click',
  DRAG_AND_DROP = 'drag_and_drop'
}
